import { getGoToLocation } from '../helpers/loginGoTo';

/**
 * creates RelayState url from the current window location's `goTo` search param combined with the
 * current window location's search params
 */
export function getRelayState(): string {
    const goTo = getGoToLocation('/internal/');

    // construct relayState from `goTo`. if `goTo` is relative, use current location as the base
    const relayState = new URL(goTo, window.location.href);

    // save current search params and remove `goTo` search param
    const currentSearchParams = new URLSearchParams(window.location.search);
    currentSearchParams.delete('goTo');

    // combine current and goTo search params
    const combinedSearchParams = new URLSearchParams([
        ...relayState.searchParams,
        ...currentSearchParams,
    ]);
    relayState.search = combinedSearchParams.toString();

    return relayState.href;
}
